import office from '@/taskpane/officejs/office-wrapper'
import MessageArgs from '../messages/message-args'

interface InsertOnCursorArgs extends MessageArgs {
  emailGuid: string
  body: string
}

export default async function insertOnCursorHandler(data: InsertOnCursorArgs) {
  try {
    await office.body.setSelectedData(data.body)
  } catch {
    // no callback
  }
}
